import { render, staticRenderFns } from "./ImageTagging.vue?vue&type=template&id=48ce7026&scoped=true"
import script from "./ImageTagging.vue?vue&type=script&lang=js"
export * from "./ImageTagging.vue?vue&type=script&lang=js"
import style0 from "./ImageTagging.vue?vue&type=style&index=0&id=48ce7026&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48ce7026",
  null
  
)

export default component.exports